<template>
<div id="appfooter">

<div style="background-color: rgb(68, 68, 68); background-image: none; background-repeat: no-repeat;background-position:0 0; background:-moz-linear-gradient(top, none, none);background:-webkit-gradient(linear, left top, left bottom, from(none), to(none));background:-o-linear-gradient(top, none, none);background:-ms-linear-gradient(top, none, none);background:linear-gradient(top, none, none);position: relative; width: 100%;min-width:1200px;background-size: auto;" bgScroll="none">
<div class="footer" cpid="30459" id="smv_Area3" style="width: 1200px; height: 299px; position: relative; margin: 0 auto;">
<div id="smv_tem_72_43" ctype="banner"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area3" isContainer="True" pvid="" tareaId="Area3"  re-direction="y" daxis="Y" isdeletable="True" style="height: 300px; width: 100%; left: 0px; top: 0px;z-index:2;">
<div class="yibuFrameContent tem_72_43  banner_Style1  " style="overflow:visible;" >
<div class="fullcolumn-inner smAreaC" id="smc_Area0" cid="tem_72_43" style="width:1200px">

	<div id="smv_tem_88_10" ctype="area"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="True" pvid="tem_72_43" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 195px; width: 351px; left: 1px; top: 57px;z-index:0;">
	<div class="yibuFrameContent tem_88_10  area_Style1  " style="overflow:visible;" >
	<div class="w-container" data-effect-name="enterTop">
	<div class="smAreaC" id="smc_Area0" cid="tem_88_10">
        <div id="smv_tem_73_3" ctype="image"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="False" pvid="tem_88_10" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 35px; width: 131px; left: 0px; top: 0px;z-index:2;">
	<div class="yibuFrameContent tem_73_3  image_Style1  " style="overflow:visible;;" >
	<div class="w-image-box image-clip-wrap" data-fillType="0" id="div_tem_73_3">
        <a target="_self" href="">
            <img 
                 src="/image/logo.png" 
                 alt="" 
                 title="" 
                 id="img_smv_tem_73_3" 
                 style="width: 129px; height:33px;"
                 class=""
             >
        </a>
	</div>
	</div>
	</div>
	</div>
	</div>
<div id="smv_tem_91_39" ctype="companyinfo"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style2" ccolor="Item0" areaId="Area0" isContainer="False" pvid="tem_88_10" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 130px; width: 320px; left: 15px; top: 53px;z-index:4;">
	<div class="yibuFrameContent tem_91_39  companyinfo_Style2  " style="overflow:hidden;height:180px;" >
	<ul class="w-company-info iconStyle1">
       <li class="company-info-item">
            <a href="javascript:;"    style="padding-left:0px;margin-left: 0px;"  >
                <div class="company-info-titleBox">
                    <span class="company-info-icon   mw-icon-hide ">
                        <i class="ltd-icon  gs-dianhua"></i>
                    </span>
                    <span class="company-info-title "style="white-space:pre">联系我们：</span>
                </div>
                <div class="company-text">
                    <span class="company-info-text">森丽康科技（北京）有限公司</span>
                </div>
            </a>
        </li>
	<li class="company-info-item">
            <a href="javascript:;"    style="padding-left:0px;margin-left: 0px;"  >
                <div class="company-info-titleBox">
                    <span class="company-info-icon   mw-icon-hide ">
                        <i class="ltd-icon  gs-dizhi"></i>
                    </span>
                    <span class="company-info-title "style="white-space:pre">地址：</span>
                </div>
                <div class="company-text">
                    <span class="company-info-text">北京市丰台区南四环西路128号诺德中心1期3号楼2515</span>
                </div>
            </a>
        </li>
        <li class="company-info-item">
            <a href="javascript:;"    style="padding-left:0px;margin-left: 0px;"  >
                <div class="company-info-titleBox">
                    <span class="company-info-icon   mw-icon-hide ">
                        <i class="ltd-icon  gs-dianhua"></i>
                    </span>
                    <span class="company-info-title "style="white-space:pre">电话：</span>
                </div>
                <div class="company-text">
                    <span class="company-info-text">18501383393</span>
                </div>
            </a>
        </li>
        <li class="company-info-item">
            <a href="mailto:lijing@seelink.com.cn"    style="padding-left:0px;margin-left: 0px;"  >
                <div class="company-info-titleBox">
                    <span class="company-info-icon   mw-icon-hide ">
                        <i class="ltd-icon  gs-youxiang"></i>
                    </span>
                    <span class="company-info-title "style="white-space:pre">邮箱：</span>
                </div>
                <div class="company-text">
                    <span class="company-info-text">lijing@seelink.com.cn</span>
                </div>
            </a>
        </li>
	<li style="height:200px;">
	<span style="color:#ffffff;font-size:11px;"></span>
	</li>
	</ul>
	</div>
	</div>

	<div id="smv_tem_90_5" ctype="area"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="True" pvid="tem_72_43" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 158px; width: 246px; left: 954px; top: 10px;z-index:10;">
	<div class="yibuFrameContent tem_90_5  area_Style1  " style="overflow:visible;;" >
	<div class="w-container" data-effect-name="enterTop">
	<div class="smAreaC" id="smc_Area0" cid="tem_90_5">
        
	<div id="smv_tem_77_58" ctype="image"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="False" pvid="tem_90_5" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 120px; width: 120px; left: 0px; top: 0px;z-index:2;">
	<div class="yibuFrameContent tem_77_58  image_Style1  " style="overflow:visible;;" >
	<div class="w-image-box image-clip-wrap" data-fillType="0" id="div_tem_77_58">
	<a target="_blank" href="/image/wechat.jpg">
            <img 
                 src="/image/wechat.jpg" 
                 alt="" 
                 title="" 
                 id="img_smv_tem_77_58" 
                 style="width: 120px; height:120px;"
                 class=""
             >
        </a>
	</div>
	</div>
	</div>
	
	
	<div id="smv_tem_78_22" ctype="text"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item4" areaId="Area0" isContainer="False" pvid="tem_90_5" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 33px; width: 106px; left: 3px; top: 125px;z-index:5;">
	<div class="yibuFrameContent tem_78_22  text_Style1  " style="overflow:hidden;" >
	<div id='txt_tem_78_22' style="height: 100%;">
	<div class="editableContent" id="txtc_tem_78_22" style="height: 100%; word-wrap:break-word;">
        <p style="text-align:center"><span style="color:#aaaaaa"><span style="font-size:14px"><span style="font-family:Source Han Sans,Geneva,sans-serif">微信扫一扫</span></span></span></p>
	</div>
	</div>
	</div>
	</div>

	<div id="smv_tem_79_47" ctype="image"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="False" pvid="tem_90_5" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 112px; width: 112px; left: 134px; top: 0px;z-index:2;">
	<div class="yibuFrameContent tem_79_47  image_Style1  " style="overflow:visible;;" >
	<div class="w-image-box image-clip-wrap" data-fillType="0" id="div_tem_79_47">
        <!--
	<a target="_self" href="">
            <img 
                 src="//ntemimg.wezhan.cn/contents/sitefiles2047/10236014/images/-50717.png" 
                 alt="" 
                 title="" 
                 id="img_smv_tem_79_47" 
                 style="width: 110px; height:110px;"
                 class=""
             >
        </a>
	-->
	</div>
	</div>
	</div>

	<div id="smv_tem_80_47" ctype="text"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item4" areaId="Area0" isContainer="False" pvid="tem_90_5" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 33px; width: 106px; left: 137px; top: 125px;z-index:5;">
	<div class="yibuFrameContent tem_80_47  text_Style1  " style="overflow:hidden;;" >
	<div id='txt_tem_80_47' style="height: 100%;">
	<div class="editableContent" id="txtc_tem_80_47" style="height: 100%; word-wrap:break-word;">
        <p style="text-align:center"><span style="color:#aaaaaa"><span style="font-size:14px"><span style="font-family:Source Han Sans,Geneva,sans-serif"><!--官方微博--></span></span></span></p>
	</div>
	</div>
	</div>
	</div>

	</div>
	</div>
	</div>
	</div>
	</div>
	</div>
		<div id="smv_tem_87_44" ctype="area"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item0" areaId="Area0" isContainer="True" pvid="tem_72_43" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 146px; width: 511px; left: 361px; top: 88px;z-index:9;">
	<div class="yibuFrameContent tem_87_44  area_Style1  " style="overflow:visible;;" >
	<div class="w-container" data-effect-name="enterTop">
	<div class="smAreaC" id="smc_Area0" cid="tem_87_44">
        <div id="smv_tem_84_58" ctype="text"  class="esmartMargin smartAbs " cpid="30459" cstyle="Style1" ccolor="Item4" areaId="Area0" isContainer="False" pvid="tem_87_44" tareaId="Area3"  re-direction="all" daxis="All" isdeletable="True" style="height: 68px; width: 489px; left: 11px; top: 0px;z-index:6;">

		<div class="yibuFrameContent tem_84_58  text_Style1  " style="overflow:hidden;;" >
		<div id='txt_tem_84_58' style="height: 100%;">
		<div class="editableContent" id="txtc_tem_84_58" style="height: 100%; word-wrap:break-word;">
		<p><span style="color:#aaaaaa"><span style="font-family:Microsoft JhengHei"><span style="font-size:20px"><span style="line-height:1.75"></span></span></span></span></p>
		<p><span style="color:#aaaaaa"><span style="font-family:Microsoft JhengHei"><span style="font-size:22px"><span style="line-height:1.75">&nbsp;&nbsp;&nbsp;&nbsp;让老人的生活每天快乐多一点！</span></span></span></span></p>
		</div>
		</div>
		</div>
	</div>
	</div>
	</div>
	</div>
	</div>


</div>
</div>
</div>
</div>
</div>

<div style="line-height: 2.5;text-align:center;font-size:13px;color:#999999;">
    Copyright © 2023 | 森丽康科技（北京）有限公司 | 京ICP备2023014629号-1
</div>
</div>
</template>

<script>
export default {
  name: 'appfooter',
   mounted() {
  }
};
</script>

<style>

</style>
